var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[_c('div',[_c('InformationIcon')],1),_c('transition',{attrs:{"name":"tooltip"}},[_c('div',{staticClass:"info-box"},[_c('div',{staticClass:"password-rules"},[_c('PasswordRules',{ref:"passwordRules",attrs:{"password":_vm.password,"confirmPassword":_vm.confirmPassword,"tooltip":true,"big":true}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }